query conversationList ($page: Int, $tz: String, $onlyUnread: Boolean, $teamId: ID!, $messaged: Boolean, $called: Boolean, $messagedBefore: String, $idBefore: ID) {
  conversationList(page: $page, onlyUnread: $onlyUnread, teamId: $teamId, messaged: $messaged, called: $called, messagedBefore: $messagedBefore, idBefore: $idBefore) {
    list {
      id
      hasUnreads
      formattedMessagedAt(tz: $tz)
      mostRecentCommunication
      homeNumber {
        id
        label
        formattedNumber
      }
      messagedAt
      teacherPhoneNumber {
        id
      }
      team {
        id
      }
      hasUnreads
      updatedAt(tz: $tz)
    }
    count
    remaining
  }
}
